import { render, staticRenderFns } from "./BlogBlockContent.vue?vue&type=template&id=70353ca5&"
import script from "./BlogBlockContent.vue?vue&type=script&lang=js&"
export * from "./BlogBlockContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports